(function () {
    'use strict';

    var root = document.querySelector('[data-locations-map]');
    if (!root) return;

    var rail = root.querySelector('[data-locations-rail]');
    var railPrevious = root.querySelector('[data-locations-rail-prev]');
    var railNext = root.querySelector('[data-locations-rail-next]');
    var directoryFilter = root.querySelector('[data-location-filter]');

    if (rail && railPrevious && railNext) {
        railPrevious.addEventListener('click', function () {
            rail.scrollBy({ left: -300, behavior: 'smooth' });
        });
        railNext.addEventListener('click', function () {
            rail.scrollBy({ left: 300, behavior: 'smooth' });
        });
    }

    if (directoryFilter) {
        directoryFilter.addEventListener('input', function (event) {
            var query = event.target.value.trim().toLowerCase();

            root.querySelectorAll('[data-location-name]').forEach(function (link) {
                link.hidden = Boolean(query && !link.dataset.locationName.includes(query));
            });
            root.querySelectorAll('.locations-hub__group').forEach(function (group) {
                group.hidden = Boolean(query && !group.querySelector('[data-location-name]:not([hidden])'));
            });
        });
    }
})();